import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoginService } from '@ebw-monorepo/login';
import { UtilsService } from '@ebw-monorepo/utils';
import { API_URLS, ApiUrlService } from 'libs/ng-components/utils/src/lib/services/api-url.service';
import { Observable, catchError, map, throwError } from 'rxjs';
import { CavoRaccordo } from '../models/cavo-raccordo.model';

@Injectable({
  providedIn: 'root'
})
export class RaccordoService {
  constructor(
    private _http: HttpClient,
    private _loginService: LoginService,
    private _utilsService: UtilsService,
    private _apiUrlService: ApiUrlService
  ) {}

  public getRaccordo(id: number): Observable<any> {
    let url = `${this._apiUrlService.createUrl(API_URLS.FIBER_JOINTS.JOINTS.GET)}?id=${id}`;
    return this._utilsService.getRequest(url, {});
  }

  public addRaccordo(data: CavoRaccordo): Observable<any> {
    let url = `${this._apiUrlService.createUrl(API_URLS.FIBER_JOINTS.JOINTS.ADD)}`;
    return this._utilsService.postRequest(url, data, false);
  }

  public updateRaccordo(data: CavoRaccordo): Observable<any> {
    let url = `${this._apiUrlService.createUrl(API_URLS.FIBER_JOINTS.JOINTS.UPDATE)}`;
    return this._utilsService.postRequest(url, data, false, {}, 'application/json');
  }

  public uploadRaccordoFile(formData: FormData): Observable<any> {
    let url = `${this._apiUrlService.createUrl(API_URLS.FIBER_JOINTS.JOINTS.UPLOAD)}`;
    return this._utilsService.postRequest(url, formData, false, {}, 'FILE');
  }

  public deleteRaccordoFile(id): Observable<any> {
    let url = `${this._apiUrlService.createUrl(API_URLS.FIBER_JOINTS.JOINTS.DELETE)}?id=${id}`;
    return this._utilsService.deleteRequest(url, undefined, false);
  }

  public downloadRaccordoFile(url) {
    const token = this._loginService.getToken();
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    const request = this._http.get(url, { headers, responseType: 'blob' });
    return request.pipe(
      map((blob) => window.URL.createObjectURL(blob)),
      catchError((error) => throwError(() => error))
    );
  }

  public autocompleteEdifici(term: string): Observable<string[]> {
    const url = `${this._apiUrlService.createUrl(API_URLS.FIBER_JOINTS.JOINTS.AUTOCOMPLETE_EDIFICI)}?term=${encodeURIComponent(term)}`;
    return this._utilsService.getRequest(url, {}).pipe(map((res: { suggestions: string[] }) => res.suggestions ?? []));
  }
}
